export default __webpack_public_path__ + "static/media/sleep-red.73f5ec42.svg";